<nz-layout class="app-layout">
  <nz-sider
    class="app-sidebar"
    nzCollapsible
    nzBreakpoint="md"
    [(nzCollapsed)]="appService.isSidebarCollapsed"
    [nzTrigger]="null"
    nzTheme="dark"
  >
    <div class="sidebar-logo">
      <a href="/" target="_blank">
        <img nz-image nzSrc="/assets/images/NFL_Shield_rgb.png" nzDisablePreview="true" alt="NFL LOGO" />
      </a>
    </div>
    <!-- app sidebar -->
    <app-sidebar></app-sidebar>
  </nz-sider>

  <nz-layout>
    <nz-header>
      <app-header></app-header>
    </nz-header>
    <nz-content>
      <div class="main-content nfl-background-color">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
